<template>
  <div>
    <div class="flex flex-end flex-vertical-center mb-75">
      <button-outlined
        @click="$refs.tablePresetModal.open()"
        color="is-secondary"
        is-short
      >
        Manage Default Presets
      </button-outlined>
    </div>

    <modal-container>
      <modal-default
        ref="tablePresetModal"
        title="Manage Default Presets"
        is-double-column
      >
        <p class="mb-150">Choose how you would like to see Inbox, Leads table and Contacts table by default.</p>

        <form-field-select
          label="Default Inbox Preset"
          v-model="form.default_inbox_preset_id"
        >
          <option :value="null">None</option>
          <option
            v-for="preset in inboxTablePresets"
            :key="preset.id"
            :value="preset.id"
          >{{ preset.label }}</option>
        </form-field-select>

        <form-field-select
          label="Default Leads Table Preset"
          v-model="form.default_leads_table_preset_id"
        >
          <option :value="null">None</option>
          <option
            v-for="preset in leadsTablePresets"
            :key="preset.id"
            :value="preset.id"
          >{{ preset.label }}</option>
        </form-field-select>

        <form-field-select
          label="Default Contacts Table Preset"
          v-model="form.default_contacts_table_preset_id"
        >
          <option :value="null">None</option>
          <option
            v-for="preset in contactsTablePresets"
            :key="preset.id"
            :value="preset.id"
          >{{ preset.label }}</option>
        </form-field-select>

        <template v-slot:footer>
          <button-default :loading="saving" @click="update">
            Update
          </button-default>
        </template>
      </modal-default>
    </modal-container>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import api from "../api";
import localStorageService from "../services/localStorage";

export default {
  name: "UserDefaultPresetForm",
  mixins: [FormMixin],
  data() {
    return {
      saving: false,
      form: {
        default_inbox_preset_id: null,
        default_leads_table_preset_id: null,
        default_contacts_table_preset_id: null,
      },
      validationErrors: {}
    }
  },
  mounted() {
    this.form.default_inbox_preset_id = this.user.default_inbox_preset_id
    this.form.default_leads_table_preset_id = this.user.default_leads_table_preset_id
    this.form.default_contacts_table_preset_id = this.user.default_contacts_table_preset_id
  },
  computed: {
    user() {
      return this.$store.getters.users.find(u => u.id === localStorageService.getAuthUser().id);
    },
    leadsTablePresets() {
      return this.$store.getters.leadsTableConfigurations
    },
    contactsTablePresets() {
      return this.$store.getters.contactsTableConfigurations
    },
    inboxTablePresets() {
      return this.$store.getters.inboxTableConfigurations
    },
  },
  methods: {
    update() {
      this.saving = true;
      return api.users.updateDefaultTablePresets(this.user.id, this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: "Default Table Presets were saved",
            type: 'is-success'
          });

          return res;
        })
        .finally(() => this.saving = false);
    }
  }
}
</script>

<style scoped>

</style>
